// Generated by npm run build:i18n. Edit the per-window JSON catalogs.
import ru0 from './ru/AccountSettingsPage.json'
import ru1 from './ru/AdminPage.json'
import ru2 from './ru/AdminPanelPage.json'
import ru3 from './ru/CollectivePage.json'
import ru4 from './ru/Controls.json'
import ru5 from './ru/Docflow.json'
import ru6 from './ru/DriverRegistration.json'
import ru7 from './ru/DriverRegistrationForm.json'
import ru8 from './ru/EmployeeCard.json'
import ru9 from './ru/Integrations.json'
import ru10 from './ru/KomurSvyazPage.json'
import ru11 from './ru/Login.json'
import ru12 from './ru/LoginForm.json'
import ru13 from './ru/MainPage.json'
import ru14 from './ru/Maps.json'
import ru15 from './ru/Mui.json'
import ru16 from './ru/NoMatch.json'
import ru17 from './ru/Preferences.json'
import ru18 from './ru/ProfilePage.json'
import ru19 from './ru/QrForm.json'
import ru20 from './ru/QuizForm.json'
import ru21 from './ru/RegisterEmployeeForm.json'
import ru22 from './ru/RegisterForm.json'
import ru23 from './ru/ReportCard.json'
import ru24 from './ru/ReportsPage.json'
import ru25 from './ru/RequestsPage.json'
import ru26 from './ru/ServerMessages.json'
import ru27 from './ru/WorkspacePage.json'
import ru28 from './ru/common.json'
import ru29 from './ru/shared.json'
import ru30 from './ru/system.json'
import ky0 from './ky/AccountSettingsPage.json'
import ky1 from './ky/AdminPage.json'
import ky2 from './ky/AdminPanelPage.json'
import ky3 from './ky/CollectivePage.json'
import ky4 from './ky/Controls.json'
import ky5 from './ky/Docflow.json'
import ky6 from './ky/DriverRegistration.json'
import ky7 from './ky/DriverRegistrationForm.json'
import ky8 from './ky/EmployeeCard.json'
import ky9 from './ky/Integrations.json'
import ky10 from './ky/KomurSvyazPage.json'
import ky11 from './ky/Login.json'
import ky12 from './ky/LoginForm.json'
import ky13 from './ky/MainPage.json'
import ky14 from './ky/Maps.json'
import ky15 from './ky/Mui.json'
import ky16 from './ky/NoMatch.json'
import ky17 from './ky/Preferences.json'
import ky18 from './ky/ProfilePage.json'
import ky19 from './ky/QrForm.json'
import ky20 from './ky/QuizForm.json'
import ky21 from './ky/RegisterEmployeeForm.json'
import ky22 from './ky/RegisterForm.json'
import ky23 from './ky/ReportCard.json'
import ky24 from './ky/ReportsPage.json'
import ky25 from './ky/RequestsPage.json'
import ky26 from './ky/ServerMessages.json'
import ky27 from './ky/WorkspacePage.json'
import ky28 from './ky/common.json'
import ky29 from './ky/shared.json'
import ky30 from './ky/system.json'
import en0 from './en/AccountSettingsPage.json'
import en1 from './en/AdminPage.json'
import en2 from './en/AdminPanelPage.json'
import en3 from './en/CollectivePage.json'
import en4 from './en/Controls.json'
import en5 from './en/Docflow.json'
import en6 from './en/DriverRegistration.json'
import en7 from './en/DriverRegistrationForm.json'
import en8 from './en/EmployeeCard.json'
import en9 from './en/Integrations.json'
import en10 from './en/KomurSvyazPage.json'
import en11 from './en/Login.json'
import en12 from './en/LoginForm.json'
import en13 from './en/MainPage.json'
import en14 from './en/Maps.json'
import en15 from './en/Mui.json'
import en16 from './en/NoMatch.json'
import en17 from './en/Preferences.json'
import en18 from './en/ProfilePage.json'
import en19 from './en/QrForm.json'
import en20 from './en/QuizForm.json'
import en21 from './en/RegisterEmployeeForm.json'
import en22 from './en/RegisterForm.json'
import en23 from './en/ReportCard.json'
import en24 from './en/ReportsPage.json'
import en25 from './en/RequestsPage.json'
import en26 from './en/ServerMessages.json'
import en27 from './en/WorkspacePage.json'
import en28 from './en/common.json'
import en29 from './en/shared.json'
import en30 from './en/system.json'

export default {
  ru: {
    "AccountSettingsPage": ru0,
    "AdminPage": ru1,
    "AdminPanelPage": ru2,
    "CollectivePage": ru3,
    "Controls": ru4,
    "Docflow": ru5,
    "DriverRegistration": ru6,
    "DriverRegistrationForm": ru7,
    "EmployeeCard": ru8,
    "Integrations": ru9,
    "KomurSvyazPage": ru10,
    "Login": ru11,
    "LoginForm": ru12,
    "MainPage": ru13,
    "Maps": ru14,
    "Mui": ru15,
    "NoMatch": ru16,
    "Preferences": ru17,
    "ProfilePage": ru18,
    "QrForm": ru19,
    "QuizForm": ru20,
    "RegisterEmployeeForm": ru21,
    "RegisterForm": ru22,
    "ReportCard": ru23,
    "ReportsPage": ru24,
    "RequestsPage": ru25,
    "ServerMessages": ru26,
    "WorkspacePage": ru27,
    "common": ru28,
    "shared": ru29,
    "system": ru30,
  },
  ky: {
    "AccountSettingsPage": ky0,
    "AdminPage": ky1,
    "AdminPanelPage": ky2,
    "CollectivePage": ky3,
    "Controls": ky4,
    "Docflow": ky5,
    "DriverRegistration": ky6,
    "DriverRegistrationForm": ky7,
    "EmployeeCard": ky8,
    "Integrations": ky9,
    "KomurSvyazPage": ky10,
    "Login": ky11,
    "LoginForm": ky12,
    "MainPage": ky13,
    "Maps": ky14,
    "Mui": ky15,
    "NoMatch": ky16,
    "Preferences": ky17,
    "ProfilePage": ky18,
    "QrForm": ky19,
    "QuizForm": ky20,
    "RegisterEmployeeForm": ky21,
    "RegisterForm": ky22,
    "ReportCard": ky23,
    "ReportsPage": ky24,
    "RequestsPage": ky25,
    "ServerMessages": ky26,
    "WorkspacePage": ky27,
    "common": ky28,
    "shared": ky29,
    "system": ky30,
  },
  en: {
    "AccountSettingsPage": en0,
    "AdminPage": en1,
    "AdminPanelPage": en2,
    "CollectivePage": en3,
    "Controls": en4,
    "Docflow": en5,
    "DriverRegistration": en6,
    "DriverRegistrationForm": en7,
    "EmployeeCard": en8,
    "Integrations": en9,
    "KomurSvyazPage": en10,
    "Login": en11,
    "LoginForm": en12,
    "MainPage": en13,
    "Maps": en14,
    "Mui": en15,
    "NoMatch": en16,
    "Preferences": en17,
    "ProfilePage": en18,
    "QrForm": en19,
    "QuizForm": en20,
    "RegisterEmployeeForm": en21,
    "RegisterForm": en22,
    "ReportCard": en23,
    "ReportsPage": en24,
    "RequestsPage": en25,
    "ServerMessages": en26,
    "WorkspacePage": en27,
    "common": en28,
    "shared": en29,
    "system": en30,
  },
}
